var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTotalTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_3886_66237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.490234 33.2837L31.3001 51.2226V28.9614L0.490234 11.1327V33.2837Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.8839 18.0671V40.044L31.2998 51.2226V28.9614L49.8839 18.0671Z",
    fill: "#2B5586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9804 0.200012L0.466797 11.1327L31.2767 28.9614L49.8608 18.0672L18.9804 0.200012Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.6437 20.5063L32.9766 29.83V48.704L48.695 39.2536L48.6437 20.5063Z",
    fill: "#475A75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.0421 1.745L3.41211 10.9739L31.4704 27.264L47.1593 18.0672L19.0421 1.745Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.63672 14.9759V31.8682L4.24459 32.9148V15.9534L2.63672 14.9759Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.71875 16.7835V33.6758L7.32534 34.7237V17.761L5.71875 16.7835Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.7998 18.5924V35.4846L10.4064 36.5313V19.5699L8.7998 18.5924Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.8809 20.4V37.2922L13.4887 38.3389V21.3775L11.8809 20.4Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.9629 22.2089V39.1011L16.5695 40.1477V23.185L14.9629 22.2089Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.0439 24.0164V40.9087L19.6505 41.9553V24.9939L18.0439 24.0164Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.127 25.8253V42.7176L22.7335 43.7642V26.8015L21.127 25.8253Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.208 27.6329V44.5252L25.8146 45.5718V28.6104L24.208 27.6329Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M27.2891 29.4405V46.3328L28.8969 47.3807V30.418L27.2891 29.4405Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M49.8416 18.0313L31.2998 28.9435V30.8497L50.1135 19.5301L49.8416 18.0313Z",
    fill: "#2B5586"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M48.7236 18.7295V40.9728L56.5489 45.4527V23.2401L48.7236 18.7295Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M57.6669 22.4984L56.5488 23.2401V45.4527L57.6669 44.743V22.4984Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M57.6669 22.4984L56.5489 23.2401L48.7236 18.7295L49.8417 18.0313L57.6669 22.4984Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M49.8955 20.6805V40.3322L55.3769 43.5016V23.8243L49.8955 20.6805Z",
    fill: "#47A7DE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M48.6954 39.2536L32.8013 30.2732L32.709 48.704L48.6954 39.2536Z",
    fill: "#253C54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M47.4826 33.7245L42.8308 36.1124L37.5059 33.3055L42.1115 30.9599L47.4826 33.7245Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M47.4829 38.4644L42.8311 41.0548V36.1124L47.4829 33.7245V38.4644Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M37.5059 33.3055V38.3338L42.8308 41.0548V36.1124L37.5059 33.3055Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M39.2236 34.2112V35.532L39.7442 35.4001L40.4481 36.2943L40.4827 34.8748L39.2236 34.2112Z",
    fill: "#DCDCEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M44.9781 32.4357L43.66 31.7567L39.2236 34.2113L40.4827 34.8748L44.9781 32.4357Z",
    fill: "#F2EFF7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M42.1008 37.2064L37.449 39.5943L32.124 36.7875L36.7297 34.4406L42.1008 37.2064Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M42.101 41.9464L37.4492 44.5367V39.5943L42.101 37.2064V41.9464Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M32.124 36.7875V41.8144L37.449 44.5367V39.5943L32.124 36.7875Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M33.8438 37.6932V39.0127L34.363 38.882L35.067 39.775L35.1016 38.3568L33.8438 37.6932Z",
    fill: "#DCDCEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M39.597 35.9164L38.2789 35.2387L33.8438 37.6932L35.1016 38.3568L39.597 35.9164Z",
    fill: "#F2EFF7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M17.2985 36.2175L9.19154 40.3779L-0.0859375 35.4879L7.93648 31.4L17.2985 36.2175Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M17.2984 44.4778L9.19141 48.99V40.3778L17.2984 36.2174V44.4778Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M-0.0859375 35.4881V44.2487L9.19154 48.9903V40.3781L-0.0859375 35.4881Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M2.90723 37.0665V39.3657L3.81357 39.138L5.03929 40.6956L5.10144 38.2221L2.90723 37.0665Z",
    fill: "#DCDCEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M12.9339 33.9718L10.6362 32.7885L2.90723 37.0662L5.10143 38.2218L12.9339 33.9718Z",
    fill: "#F2EFF7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M27.582 42.1511L19.475 46.3115L10.1992 41.4215L18.2216 37.3336L27.582 42.1511Z",
    fill: "#DDA053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M27.5816 50.4114L19.4746 54.9236V46.3114L27.5816 42.151V50.4114Z",
    fill: "#C37651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M10.1992 41.4217V50.1823L19.475 54.9239V46.3117L10.1992 41.4217Z",
    fill: "#AF5B51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M13.1924 42.9999V45.2991L14.0987 45.0714L15.3244 46.629L15.3866 44.1555L13.1924 42.9999Z",
    fill: "#DCDCEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M23.2191 39.9054L20.9213 38.7221L13.1924 42.9998L15.3866 44.1554L23.2191 39.9054Z",
    fill: "#F2EFF7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M31.2998 28.9435V51.1868L39.125 55.6667V33.4541L31.2998 28.9435Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M40.2418 32.7124L39.125 33.4541V55.6667L40.2418 54.9557V32.7124Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M40.2418 32.7124L39.125 33.4541L31.2998 28.9435L32.4179 28.2453L40.2418 32.7124Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M32.4717 30.8946V50.545L37.9531 53.7156V34.037L32.4717 30.8946Z",
    fill: "#426DB5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3886_66237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.2,
    height: 55.4667,
    fill: "white",
    transform: "translate(0.466797 0.200012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalTask);
export default __webpack_public_path__ + "static/media/icon-total-task.47435f9e5c066dc37400e29d160abe44.svg";
export { ForwardRef as ReactComponent };